import { selectedIsHiddenBalance, toggleHideBalance } from '@shared-core/features/settings'
import { useAppDispatch, useAppSelector } from '@shared-core/store'
import { useHaptic } from '@shared-ui/platform/hooks/use-haptic'
import { useCallback, useState } from 'react'

export const useBalanceHider = () => {
  const isHiddenBalance = useAppSelector(selectedIsHiddenBalance)
  const [isHideLocal, setIsHideLocal] = useState<boolean | undefined>(undefined)
  const haptic = useHaptic()
  const dispatch = useAppDispatch()
  const toggleLocal = useCallback(() => {
    if (isHideLocal !== undefined) {
      setIsHideLocal(!isHideLocal)
      return
    }
    setIsHideLocal(!isHiddenBalance)
    haptic('selection')
  }, [haptic, isHiddenBalance, isHideLocal])
  const toggleGlobal = () => {
    haptic('selection')
    dispatch(toggleHideBalance())
  }
  const isBalanceHidden = isHideLocal ?? isHiddenBalance
  return { isBalanceHidden, isBalanceShow: !isBalanceHidden, toggleLocal, toggleGlobal }
}
